import React, {useState, useEffect} from "react";
import styles from "./Header.module.scss";
import NavBar from "./NavBar";
import {Container} from "react-bootstrap";

const Header: React.FC = () => {
    const [videoSrc, setVideoSrc] = useState('');
    const [posterSrc, setPosterSrc] = useState('');
    const [fallbackSrc, setFallbackSrc] = useState('');
    const [isVideoError, setIsVideoError] = useState(false);

    useEffect(() => {
        const updateMediaSources = () => {
            if (window.innerWidth > 765) {
                setVideoSrc('./assets/video/desktop/offer.mp4'); // Видео для десктопа
                setPosterSrc('./assets/image/preloadDesktop.png'); // Постер для десктопа
                setFallbackSrc('./assets/image/preloadDesktop.png'); // Заглушка для десктопа
            } else {
                setVideoSrc('./assets/video/mobile/offer.mp4'); // Видео для мобильных
                setPosterSrc('./assets/image/preloadMob.png'); // Постер для мобильных
                setFallbackSrc('./assets/image/preloadMob.png'); // Заглушка для мобильных
            }
        };

        updateMediaSources();
        window.addEventListener('resize', updateMediaSources);

        return () => {
            window.removeEventListener('resize', updateMediaSources);
        };
    }, []);

    const VideoPlayer = () => {
        return (
            <div className={styles.videoWrapper}>
                <Container>
                    {!isVideoError ? (
                        <video
                            width="100%"
                            height="auto"
                            controls={false}
                            autoPlay={true}
                            loop={true}
                            muted={true}
                            playsInline
                            poster={posterSrc} // Предзагрузочное изображение
                            onError={() => setIsVideoError(true)} // Обработка ошибки видео
                        >
                            {videoSrc && <source src={videoSrc} type="video/mp4"/>}
                            Ваш браузер не поддерживает воспроизведение видео.
                        </video>
                    ) : (
                        <img src={fallbackSrc} // Разная заглушка для мобильных и десктопа
                             alt="Видео недоступно"
                             className='img-fluid'
                        />
                    )}
                </Container>
            </div>
        );
    };

    return (
        <header className={styles.header}>
            <NavBar/>
            <VideoPlayer/>
        </header>
    );
};

export default Header;
